module.exports = __webpack_public_path__ + "images/internal/zero_data/business.svg";